import './list-view.less'

import React, {useMemo, useRef, useState} from 'react';
import {Checkbox, Dropdown, Icon, Menu} from 'antd';
import {get} from 'lodash';
import ReactList from 'react-list';

import {ClipLoader} from 'halogenium';

import $ from 'jquery';
import classNames from 'classnames';
import {Filter, filterBool, filterDate, filterPassStatus, filterString} from './filter';
import Resizable from 're-resizable';
import {getPassClassName} from './helpers';


const fget = (obj, key, _default = '') => get(obj, key) || _default;

const stringSorter = (property) => {
  return (a, b) => {
    return fget(a, property).localeCompare(fget(b, property));
  }
};

const numberSorter = (property) => {
  return (a, b) => fget(a, property) > fget(b, property) ? 1 : -1;
};

const passStatusSorter = (property) => {
  return (a, b) => {
    const aStatus = fget(a, property);
    const bStatus = fget(b, property);

    const aCanceledAt = fget(a, 'lastPass.canceledAt');
    const bCanceledAt = fget(b, 'lastPass.canceledAt');

    if (aStatus === 'canceled' && bStatus === 'canceled' && aCanceledAt && bCanceledAt) {
      return aCanceledAt - bCanceledAt > 0 ? -1 : 1;
    }

    return aStatus.localeCompare(bStatus);
  }
};

const defaultSorter = stringSorter;

export default class ClientsListView extends React.Component {

  state = {
    height: [],
    checked: {},
    filters: {},

    sort: {
      key: '',
      asc: true
    }
  };

  componentDidMount() {

  }

  render() {
    console.log('render listview');
    const columns = this.props.columns;
    let rows = this.getFilteredRows();
    const renderRow = this.renderRow.bind(this, rows);

    return (
      <div className="r-list-view">
        <div className="r-list-header">
          <div className="th t-select"><div><Checkbox onChange={::this.onCheckAll} /></div></div>
          {columns.map(::this.renderColumn)}
        </div>
        <div className="r-list-content">
          <ReactList
            itemRenderer={renderRow}
            length={rows.length}
            type='uniform' />
        </div>
      </div>
    )
  }

  getFilteredRows() {
    let rows = this.props.items;

    rows = this.applyFilters(rows);
    rows = this.applySort(rows);

    return rows;
  }

  applySort(rows) {
    if(this.state.sort.key) {
      let sorter = this.getColSorter(this.state.sort.key);
      console.log('sorter', sorter);
      rows = this.makeSort(rows, sorter, this.state.sort.asc);
    }

    return rows;
  }

  applyFilters(rows) {
    const filtersList = Object.keys(this.state.filters);
    console.log('filters', this.state.filters)
    if(filtersList.length > 0) {
      for(const key of filtersList) {
        const data = this.state.filters[key];
        let filterFn = null;
        if(data.type === 'string') {
          filterFn = filterString(data, key);
        } else if(data.type === 'date') {
          filterFn = filterDate(data, key);
        } else if(data.type === 'bool') {
          filterFn = filterBool(data, key);
        } else if(data.type === 'passStatus') {
          filterFn = filterPassStatus(data, key);
        }

        if(filterFn) {
          rows = filterFn(rows);
        } else {
          console.error('unknown filter type', data, key);
        }
      }
    }

    return rows;
  }

  renderRow(rows, index) {
    const row = rows[index];

    return (
      <Row key={row.cid}
           user={this.props.user}
           page={this.props.page}
           row={row} columns={this.props.columns}
           onCheck={this.onCheckRow.bind(this, row)}
           onChange={this.props.onChangeEditableField}
           onClickAction={(e) => this.props.onClickAction(row, e)}
           allChecked={this.state.checked}
           checked={this.state.checked[row.cid]} />
    );
  }

  renderColumn(col) {
    return (
      <Column
        key={'col' + col.name}
        col={col}
        onResize={this.props.onChangeColSize.bind(this, col, false)}
        onResizeStop={this.props.onChangeColSize.bind(this, col, true)}
        filter={this.state.filters[col.key]}
        onChangeFilter={this.onChangeFilter.bind(this, col)}
        rows={this.props.items}
        sort={this.state.sort && this.state.sort.key === col.key && this.state.sort}
        sortBy={this.sortBy.bind(this, col)} />
    );
  }

  onChangeFilter(col, data) {
    const filters = this.state.filters;
    if(data.val === null) {
      delete filters[col.key];
    } else {
      filters[col.key] = data;
    }

    this.setState({ filters: filters });
  }

  sortBy(col) {
    if(!col.sort)
      return ;

    let asc = true;
    if(this.state.sort.key === col.key) {
      asc = !this.state.sort.asc;
    }

    this.setState({
      sort: {
        key: col.key,
        asc
      }
    });
  }

  getColSorter(colKey) {
    const col = this.props.columns.find(i => i.key === colKey);
    let sorter = defaultSorter;
    if(col.sort === 'string') {
      sorter = stringSorter;
    } else if(col.sort === 'number') {
      sorter = numberSorter;
    } else if(col.sort === 'passStatus') {
      sorter = passStatusSorter;
    }

    return sorter(col.key);
  }

  makeSort(rows, sortFn, asc) {
    rows = rows.sort(sortFn);
    if(!asc) {
      rows = rows.reverse();
    }
    return rows;
  }

  onCheckAll({ target }) {
    const checked = {};
    const rows = this.getFilteredRows();

    for(let i of rows) {
      checked[i.cid] = target.checked;
    }

    this.setState({ checked });
    this._changeChecked(checked);
  }

  onCheckRow(row, { target, nativeEvent: { shiftKey }}) {
    if (shiftKey) {
      const rows = this.getFilteredRows();
      const stopIndex = rows.findIndex(r => r.cid === row.cid);
      const startIndex = rows.findIndex(r => this.state.checked[r.cid]);

      if (startIndex === -1) {
        this.state.checked[row.cid] = target.checked;
      } else {
        const start = Math.min(startIndex, stopIndex);
        const stop = Math.max(startIndex, stopIndex);

        for (let i = start; i <= stop; i++) {
          this.state.checked[rows[i].cid] = true;
        }
      }
    } else {
      this.state.checked[row.cid] = target.checked;
    }
    this._changeChecked(this.state.checked);
  }

  _changeChecked(next) {
    this.setState({ checked: next }, () => {
      this.props.onChangeChecked(next);
    });
  }

}

export class Column extends React.Component {
  render() {
    const { col, filter, onChangeFilter, sort, sortBy, rows, onResize, onResizeStop } = this.props;
    let icon = '';
    if(sort) {
      icon = <Icon type={sort.asc ? 'sort-ascending' : 'sort-descending'} />;
    }

    return (
      <Resizable
        key={'col' + col.name}
        size={{ width: col.cfg.width + 'px' }}
        onResize={onResize}
        onResizeStop={onResizeStop}
        enable={{ right: true }}
        minWidth={30}
        className={classNames(col.sort ? 'sortable' : '', 'th', 't-' + col.key.split('.').join('_'))}>
        <div>
          <a onClick={col.sort ? sortBy : () => {}}><span>{col.name}</span>{icon}</a>
          {col.filterType
          && <Filter onChange={onChangeFilter} value={filter} col={col} rows={rows} />}
        </div>
      </Resizable>
    );
  }
}


export class Row extends React.Component {
  render() {
    const { row, checked, onClickAction, onCheck, page, allChecked, user: { type } } = this.props;
    const countChecked = Object.keys(allChecked).filter(i => allChecked[i]).length;

    const menu = (
      <Menu onClick={onClickAction}>
        <Menu.Item key="forceCheck">Проверить пропуск ({countChecked})</Menu.Item>
        {type === 'admin' && <Menu.Item key="updateMany">Изменить ({countChecked})</Menu.Item>}
        <Menu.Item key="orderUp">Переместить в начало ({countChecked})</Menu.Item>
        {type === 'admin' && page !== 'our' && <Menu.Item key="moveToOur">Переместить в наши клиенты ({countChecked})</Menu.Item>}
        {type === 'admin' && page !== 'req' && <Menu.Item key="moveToReq">Переместить в потенциальные клиенты ({countChecked})</Menu.Item>}
        {type === 'admin' && page !== 'arc' && <Menu.Item key="moveToArc">Переместить в архив ({countChecked})</Menu.Item>}

        {type === 'admin' && <Menu.Item key="sendSms">Отправить сообщение ({countChecked})</Menu.Item>}
        {(type === 'admin' || type === 'user') && <Menu.Item key="remove">Удалить ({countChecked})</Menu.Item>}
      </Menu>
    );

    return (
      <Dropdown overlay={menu} trigger={['contextMenu']} onVisibleChange={::this.onContextMenuVisibleChange}>
        <div key={row.cid} className={classNames('row', checked ? 'row-checked' : '', this.getRowClassName())}>
          <div className="td t-select"><div><Checkbox checked={checked} onChange={onCheck} /></div></div>
          <RowContent {...this.props}/>
          <div className="night-split" />
        </div>
      </Dropdown>
    );
  }

  onContextMenuVisibleChange(visible) {
    if (visible && !this.props.checked) {
      this.props.onCheck({ target: { checked: visible }, nativeEvent: { }});
    }
  }

  getRowClassName() {
    const { row } = this.props;

    const nightClassName = 'night-' + getPassClassName(row.night_lastPass);
    return `${nightClassName} ${getPassClassName(row.lastPass)}`;
  }
}

class RowContent extends React.Component {
  render() {
    const { row, checked, columns } = this.props;
    return columns.map(this.renderRowContent.bind(this, row));
  }

  renderRowContent(row, col) {
    if (!col.splited) {
      return this._renderRow(row, col);
    }

    const nightCol = { ...col, key: `night_${col.key}`, isNight: true };

    return (
      <div className={classNames('td td-split', `t-${col.key.split('.').join('_')}`)} style={{ width: col.cfg.width + 'px' }}>
        <div>
          {this._renderRow(row, col)}
          <div className="td-separator" />
          {this._renderRow(row, nightCol)}
        </div>
      </div>
    );
  }

  _renderRow(row, col) {
    const className = `${col.splited ? 'td-half' : 'td'}`;
    const style = col.splited ? {} : { width: col.cfg.width + 'px' };

    const getFormattedValue = () => {
      let content;
      if(col.formatter) {
        content = col.formatter({ row, col });
        if(typeof content === 'function') {
          content = content(fget(row, col.key));
        }
      } else {
        content = fget(row, col.key);
      }

      return content;
    };


    if(col.editable) {
      return <EditableField className={className}
                            style={style}
                            key={row.cid + col.key}
                            renderVal={getFormattedValue}
                            value={() => row[col.key]}
                            onChange={(next, initial) => this.props.onChange(row, col, next, initial)} />
    }

    return <div key={row.cid + col.key} className={classNames(className, 'td-non-edit')} style={style}><div>{getFormattedValue()}</div></div>
  }
}

function EditableField({ value, onChange, className, style, renderVal }) {
  const initialValue = value();
  const [isEdit, setEdit] = useState(false);
  const [val, setVal] = useState(initialValue);
  const [isSaving, setSaving] = useState(false);

  const el = useRef(null);
  const inp = useRef(null);

  const id = useMemo(() =>  Math.floor(Math.random() * 1000000000000), 0);
  const focusedClass = 'r-editable-field-focused-' + id;


  const onEditEnd = useMemo(() => async (e) => {
    if(!$(e.target).hasClass('r-overlay') && !$(e.target).parents(focusedClass).length) {
      return ;
    }

    const nextVal = inp.current.value;
    console.log('on change', nextVal, initialValue);

    let ok = false;
    $(document).off('click', onEditEnd);

    setEdit(false);
    setSaving(true);
    try {
      ok = await onChange(nextVal, initialValue);
    } catch(e) {
      console.error('error', e);
      ok = false;
    }
    setSaving(false);

    if(!ok) {
      setVal(value());
    }
  });

  const onDoubleClick = () => {
    setEdit(true);

    setTimeout(() => {
      inp.current.focus();
    });
    $(document).on('click', onEditEnd);
  };

  const classname = classNames('r-editable-field', isEdit ? focusedClass : '', className);

  const saving = isSaving
    ? <div className="saving-overlay"><ClipLoader size={14} color={'#3498db'} /></div>
    : <Icon type="form" width={6} height={6} onClick={onDoubleClick} />;

  const valRendored = renderVal ? renderVal(val) : val;

  return (
    <div ref={el} className={classname} onDoubleClick={onDoubleClick} style={style}>
      { isEdit
        ? <div className="edit-mode"><div className="r-overlay" /><textarea ref={inp} value={val} onChange={({target: {value}}) => setVal(value)} /></div>
        : <div><div>{valRendored}</div>{saving}</div> }
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/pages/clients/list-view.js